import  {Stack, Dialog, DialogActions, DialogContent, DialogTitle,
  Button, TextField  } from '@mui/material';
import IconCancel from '@mui/icons-material/Cancel';
import moment from 'moment';
import 'moment/dist/locale/de';

const EditDates = ({open, close, getInfo, updateChanged}) => {

  const updateDates = (field) => (e) => {
    const v = moment(e.target.value);
    if (field==='ankunft') {
      updateChanged(parseInt(v.format('YYYYMMDD')), 'ankunft');
      updateChanged(parseInt(v.add(getInfo('dauer'), 'days').format('YYYYMMDD')), 'abreise');
    }
    if (field==='dauer') {
      updateChanged(parseInt(e.target.value), 'dauer');
      updateChanged(parseInt(moment(getInfo('ankunft')+"").add(e.target.value, 'days').format('YYYYMMDD')), 'abreise');
    }
    if (field==='abreise') {
      updateChanged(parseInt(v.format('YYYYMMDD')), 'abreise');
      updateChanged(parseInt(v.diff(moment(getInfo('ankunft')+""), 'days')), 'dauer');
    }
  }
  return (
    <>
      <Dialog open={open} onClose={close}>
        <DialogActions style={{position:'absolute', right:0}}>
          <Button label="ra.action.cancel" onClick={close}><IconCancel /></Button>
        </DialogActions>
        <DialogTitle sx={{pb:1}}>Edit dates</DialogTitle>
        <DialogContent sx={{pb:1}}>
          <Stack direction="row" spacing={2} sx={{pb:1, '& > *':{flex:1}}}>
            <TextField label="Arrival" type="date" value={moment(getInfo('ankunft')+"").format('YYYY-MM-DD')} onChange={updateDates('ankunft')} />
            <TextField label="Nights" type="number" value={getInfo('dauer')} onChange={updateDates('dauer')} />
            <TextField label="Departure" type="date" value={moment(getInfo('abreise')+"").format('YYYY-MM-DD')} onChange={updateDates('abreise')} />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={close}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default EditDates;